<template>
  <base-button id="pdp-size-chart" class="flex items-center gap-1" @click="emit('open')">
    <vf-icon v-if="showIcon" name="size" :size="iconSize" />
    {{ $t.sizeChart }}
  </base-button>
</template>

<script lang="ts" setup>
const emit = defineEmits<{
  open: []
}>()

const { iconSize, showIcon } = useAppConfig().pages.pdp.sizeChart
</script>
